import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export function SiteForm({
  defaultValues,
  onSubmit,
}: {
  defaultValues?: { name: string; client?: string; address?: string };
  onSubmit: (data: {
    name: string;
    client?: string;
    address?: string;
  }) => Promise<void>;
}) {
  const navigate = useNavigate();
  const [name, setName] = useState(defaultValues?.name ?? "");
  const [client, setClient] = useState(defaultValues?.client ?? "");
  const [address, setAddress] = useState(defaultValues?.address ?? "");
  const [saving, setSaving] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!name.trim()) return;

    setSaving(true);
    try {
      await onSubmit({
        name: name.trim(),
        client: client.trim() || undefined,
        address: address.trim() || undefined,
      });
      navigate(-1);
    } finally {
      setSaving(false);
    }
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <Label htmlFor="name">Nom du site *</Label>
        <Input
          id="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Ex : Réseau eau potable Lyon 3e"
          required
          autoFocus
          maxLength={255}
        />
      </div>

      <div className="flex flex-col gap-2">
        <Label htmlFor="client">Client</Label>
        <Input
          id="client"
          value={client}
          onChange={(e) => setClient(e.target.value)}
          placeholder="Ex : Veolia"
          maxLength={255}
        />
      </div>

      <div className="flex flex-col gap-2">
        <Label htmlFor="address">Adresse</Label>
        <Input
          id="address"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          placeholder="Ex : 12 rue de la République, Lyon"
          maxLength={500}
        />
      </div>

      <div className="flex gap-3 pt-2">
        <Button
          type="button"
          variant="outline"
          className="flex-1"
          onClick={() => navigate(-1)}
        >
          Annuler
        </Button>
        <Button type="submit" className="flex-1" disabled={!name.trim() || saving}>
          {saving ? "Enregistrement..." : defaultValues ? "Modifier" : "Créer"}
        </Button>
      </div>
    </form>
  );
}
